import { PortfolioModel } from "../../../screens/portfolio-info/types/PortfolioModel";
import { assetService } from "../../../shared/services/AssetService";
import { OrderState } from "../../../shared/types/OrderState";
import { TargetPlatform } from "../../../shared/types/TargetPlatform";

export type PositionForUpdate = {
    symbol: string;
    targetPlatform: TargetPlatform;
    customImpliedVolatility: number;
    customImpliedVolatilityStep: number | null;
}

export type OrderForUpdate = {
    id: number;
    customImpliedVolatility: number;
    customImpliedVolatilityStep: number | null;
}

export type CustomImpliedVolatilityInfo = {
    positionsForUpdate: PositionForUpdate[];
    ordersForUpdate: OrderForUpdate[];
}

class CustomImpliedVolatilityInfoBuilder {
    build = (
        portfolio: PortfolioModel,
        optionSymbol?: string,
        targetPlatform?: TargetPlatform,
    ): CustomImpliedVolatilityInfo => {
        const positionsForUpdate = portfolio.positions
            .filter(x =>
                (optionSymbol === undefined || x.symbol === optionSymbol) &&
                (targetPlatform === undefined || x.targetPlatform === targetPlatform) &&
                x.customImpliedVolatility !== null &&
                assetService.isPositionOption(x) &&
                x.size !== 0 &&
                !assetService.isPositionOptionExpired(x))
            .map((x): PositionForUpdate => ({
                symbol: x.symbol,
                targetPlatform: x.targetPlatform,
                customImpliedVolatility: x.customImpliedVolatility!,
                customImpliedVolatilityStep: x.customImpliedVolatilityStep,
            }));

        const ordersForUpdate = portfolio.orders
            .filter(x =>
                (optionSymbol === undefined || x.symbol === optionSymbol) &&
                (targetPlatform === undefined || x.targetPlatform === targetPlatform) &&
                x.customImpliedVolatility !== null &&
                assetService.isOption(x) &&
                x.size !== 0 &&
                !assetService.isOptionExpired(x) &&
                x.state === OrderState.Active)
            .map((x): OrderForUpdate => ({
                id: x.externalId,
                customImpliedVolatility: x.customImpliedVolatility!,
                customImpliedVolatilityStep: x.customImpliedVolatilityStep,
            }));

        return {
            positionsForUpdate,
            ordersForUpdate,
        };
    };
}

export const customImpliedVolatilityInfoBuilder = new CustomImpliedVolatilityInfoBuilder();
